
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import AdminPage from "@/pages/admin/AdminPage";
import SubscriptionPlanCreatePage from "@/pages/admin/subscription-plans/SubscriptionPlanCreatePage";
import SubscriptionPlanEditPage from "@/pages/admin/subscription-plans/SubscriptionPlanEditPage";
import SubscriptionPlansListPage from "@/pages/admin/subscription-plans/SubscriptionPlansListPage";

// Admin routes don't check for subscription feature flags
// Admins should always be able to manage subscriptions
export function AdminRoutes() {
  return (
    <>
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/subscription-plans" 
        element={
          <ProtectedRoute>
            <SubscriptionPlansListPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/subscription-plans/new" 
        element={
          <ProtectedRoute>
            <SubscriptionPlanCreatePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/subscription-plans/:planId/edit" 
        element={
          <ProtectedRoute>
            <SubscriptionPlanEditPage />
          </ProtectedRoute>
        } 
      />
    </>
  );
}
